define(['angular'], function(angular) {
    function DevanceProvider() {
        var bdcUrl;

        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                self.getBdcUrl = function() {
                    return bdcUrl;
                };

                return self;
            }
        ];
    }

    angular.module('app.devance.common.devanceProvider', []).provider('devance', DevanceProvider);
});